export default process.env.PRESENTATION ? sessionStorage : localStorage;

export const ACCEPTED_POPUP_KEY = "bt-accepted-demo-popup";
